import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HttpClientModule, provideHttpClient, withFetch} from '@angular/common/http';
import { LoginComponent } from './components/login/login.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './components/register/register.component';
import { BenefitsComponent } from './components/benefits/benefits.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { LayoutComponent } from './components/layouts/layout/layout.component';
import { BenefitDetailsComponent } from './components/benefit-details/benefit-details.component';
import { BenefitsFilterComponent } from './components/benefits-filter/benefits-filter.component';
import { UserComponent } from './components/user/user.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { SwiperModule } from 'swiper/angular';
import { BenefitsItemModule } from './components/benefits-item/benefits-item.module';
import { BenefitsItemComponent } from './components/benefits-item/benefits-item.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { ConversorComponent } from './components/conversor/conversor.component';
import { ShellAppComponent } from './components/shell-app/shell-app.component';
import { ShellAppModule } from './components/shell-app/shell-app.module';
import {MatExpansionModule} from '@angular/material/expansion';
import { CategoriesComponent } from './components/categories/categories.component';
import { CategoriesModule } from './components/categories/categories.module';
import { ShellProgramComponent } from './components/shell-program/shell-program.component';
import { PointsHistoricComponent } from './components/points-historic/points-historic.component';
import { PointsHistoricModule } from './components/points-historic/points-historic.module';
import { ConversorModule } from './components/conversor/conversor.module';
import { BenefitBoxComponent } from './components/benefit-box/benefit-box.component';
import { SliderComponent } from './components/slider/slider.component';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { SorteosComponent } from './components/sorteos/sorteos.component';
import { SorteosHistoricComponent } from './components/sorteos-historic/sorteos-historic.component';
import { TransferComponent } from './components/transfer-points/transferPoints.component';
import { QuestionsComponent } from './components/questions/questions.component';
import { PopUpComponent } from './components/common/pop-up/pop-up.component';
import { CompleteRegisterComponent } from './components/complete-register/complete-register.component';
import { SafeUrlPipe } from './shared/pipes/safe-url.pipe';
import { FestivitiesOpportunitiesComponent } from './components/festivities-opportunities/festivities-opportunities.component';
import { BranchesComponent } from './components/common/branches/branches.component';
import { TransferBlockedModule } from './components/transfer-blocked-component/transfer-blocked.module';
import { TransferCodeConfirmationModule } from './components/transfer-code-confirmation/transfer-code-confirmation.module';
import { SemicolonToBreakPipe } from './shared/pipes/semicolonBreakLinea.pipe';
import { CountdownPipeModule } from './pipe/pipe.module';
import { SpinnerComponentModule } from './components/spinner/spinner.component.module';
import { CapitalizePipe } from './shared/pipes/capitalize.pipe';
import { ComfirmRegisterComponent } from './components/common/comfirm-register/comfirm-register.component';

import { PromoGamerComponent } from './components/promo-gamer/promo-gamer.component';
import { DropdownSearchComponent } from './components/common/dropdown-search/dropdown-search.component';
import { FormartNumberForKmModule } from './pipe/formatNumberForKm/formatNumberForKm.module';
import { ToTitleCaseModule } from './pipe/toTitleCase/toTitleCase.module';
import { FormatDescriptionPipeModule } from './pipe/formatDrawDescription/formatDrawDescription.module';
import { HighlightSemicolonPipeModule } from './pipe/highlightSemicolon/highlight-semicolon.module';
import { PasswordRequirementsComponent } from './components/common/password-requirements/password-requirements.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    RegisterComponent,
    BenefitsComponent,
    HeaderComponent,
    LayoutComponent,
    BenefitDetailsComponent,
    BenefitsFilterComponent,
    UserComponent,
    BenefitsItemComponent,
    FooterComponent,
    ConversorComponent,
    TransferComponent,
    ShellAppComponent,
    CategoriesComponent,
    ShellProgramComponent,
    PointsHistoricComponent,
    BenefitBoxComponent,
    SliderComponent,
    PagenotfoundComponent,
    SorteosComponent,
    SorteosHistoricComponent,
    QuestionsComponent,
    PopUpComponent,
    CompleteRegisterComponent,
    SafeUrlPipe,
    FestivitiesOpportunitiesComponent,
    BranchesComponent,
    SemicolonToBreakPipe,
    CapitalizePipe,
    ComfirmRegisterComponent,
    DropdownSearchComponent,
    PromoGamerComponent,
    PasswordRequirementsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    MatTabsModule,
    SwiperModule,
    BenefitsItemModule,
    ShellAppModule,
    MatExpansionModule,
    CategoriesModule,
    PointsHistoricModule,
    ConversorModule,
    ReactiveFormsModule,
    TransferBlockedModule,
    TransferCodeConfirmationModule,
    CountdownPipeModule,
    SpinnerComponentModule,
    FormartNumberForKmModule,
    ToTitleCaseModule,
    FormatDescriptionPipeModule,
    HighlightSemicolonPipeModule
  ],
  providers: [
    provideClientHydration(),
    provideHttpClient(withFetch())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
